<template>
  <div
    :is="role"
    class="avatar"
    :class="{
      'logged-in': loginState
    }"
    v-on="$listeners"
  >
    <img
      v-if="url || defaultUrl"
      class="avatar__img"
      :src="url || defaultUrl"
    >
    <i
      v-else
      class="isif isif-account avatar__img"
    />
  </div>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    defaultUrl: {
      type: String,
      default: ''
    },
    role: {
      type: String,
      default: 'div'
    },
    loginState: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="stylus" scoped>
$avatar-size = 50px
.avatar {
   text-align: center
   padding: 0
   width: 32px
   height: 32px
   border: 1px solid #fff
   border-radius: 50% 50%
   background-color: unset;
   overflow: hidden

   .avatar__img {
     font-size: 20px
     line-height: 30px
     width: 100%
     //height: 100%
     object-fit: cover
    }
   .isif-account{
     color: #FFF;
   }
}

.logged-in{
  width: 44px
  height: 44px
  background-color: #CCCCD6
  .avatar__img {
    font-size: 24px
  }
}

@media (max-width: 1024px) {
  .logged-in{
    width: 36px
    height: 36px
  }
}

</style>
